import React, {useEffect, useState, useContext} from 'react';
import CryptoJS from 'crypto-js';
import "./css/ForgotPass.css";
import forgetImage from './images/login/reset-password/reset-password_pana.png';
import frtImg from "./images/login/Group.png";
import check from "./images/icons/check.png";
import frtImage from "./images/login/reset-password/pana.png";
import Back from "./images/Mobile/backBtn.png";
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Lottie from "lottie-react";
import Load from "./images/lottie/load1.json";
import axios from 'axios'
import { DBContext } from './DBContext' 

function ForgetPass() {

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const { logginedDB , sideNavState , sideNavStateFunc } = useContext(DBContext);

    const navigate = useNavigate(null)

    const [email,setEmail] = useState('')
    const handleOnChangeEmail = (e) => {
        const email = e.target.value
        setEmail(email)
    }

    const [password,setPassword] = useState({})
    const handleOnChangePassword = (e,field) => {
        const value = e.target.value
        setPassword((prev) => ({
            ...prev,
            [field] : value
        }))
    }

    const [key,setKey] = useState('')
    const [countdown, setCountdown] = useState(600);
    const [formattedTime, setFormattedTime] = useState('10:00');
    const [userFound, setUserFound] = useState(false);
    const [keySuccess, setKeySuccess] = useState(false);

    const generateKey = () => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        return Array.from({ length: 40 }, () => characters[Math.floor(Math.random() * characters.length)]).join('');
    };
    useEffect(() => {
        if (userFound) {
            const countdownInterval = setInterval(() => {
                setCountdown((prevCountdown) => {
                    if (prevCountdown < 1) {
                        clearInterval(countdownInterval);
                        const key = generateKey()
                        // const G_key = encryptData(otp)
                        setKey(key)
                        return 0;
                    }
                    return prevCountdown - 1;
                });
            }, 1000);
    
            return () => clearInterval(countdownInterval); 
        }
    }, [userFound]);

    useEffect(() => {
        if (userFound) {

            if (countdown === 0) {
                return setUserFound(false) , setCountdown(600) ,setKey('')
            };
    
            const minutes = Math.floor(countdown / 60);
            const seconds = countdown % 60;
            const formatted = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            setFormattedTime(formatted);
        
            // Decrease countdown every second
            const timerId = setInterval(() => {
            setCountdown(prevCountdown => {
                if (prevCountdown <= 1) {
                clearInterval(timerId);
                    setKey('')
                return 0;
                }
                return prevCountdown - 1;
            });
            }, 1000);
        
            // Cleanup interval on component unmount
            return () => clearInterval(timerId);
        }
        
      }, [userFound,countdown]);

    const [animate, setAnimate] = useState(false);
    useEffect(() => {
        if (userFound) {
          setAnimate(true); // Trigger animation on mount
          // Optionally, you might want to reset animation state after some time
          // setTimeout(() => setAnimate(false), 2000); // Adjust time as needed
        }
      }, [userFound]);

    const handleSubmit = async () => {
        if (password.password === password.confirmPass) {
            try{
                const response = await fetch(
                    `${apiBaseUrl}/changePassword?email=${email}&password=${password.password}&db=${logginedDB}`
                );

                if (response.ok) {
                    navigate('/')
                }

            } catch (error) {
                // //(error);
            }
        } else if (password.password === '' ) {
            toast.error("Invalid password!",{
                className: 'custom-toast-error',
                bodyClassName: 'custom-toast-error-container',
                closeButtonClassName: 'custom-toast-error-close-button',
                onClose: () => {}
            });
        } else if (password.password !== password.confirmPass) {
            toast.error("Password not match!",{
                className: 'custom-toast-error',
                bodyClassName: 'custom-toast-error-container',
                closeButtonClassName: 'custom-toast-error-close-button',
                onClose: () => {}
            });
        }
    }

    const [loading,setLoading] = useState(false)

    const handleSendKey = async () => {

        toast.dismiss()
        const key = generateKey()
        setKey(key)

        try{
            //("hiii");
            
            setLoading(true)
            const response = await fetch(
                `${apiBaseUrl}/forgotPass?email=${encodeURIComponent(email)}&key=${encodeURIComponent(key)}&db=${encodeURIComponent(logginedDB)}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            );            

            if (response.status == 200) {
                setTimeout(() => {
                    setLoading(false)
                    setUserFound(true)
                }, 1000);
            } else if (response.status == 404) {
                setUserFound(false)
                if (email === '') {
                    setUserFound(false)
                    setLoading(false);  
                    toast.error("Invalid email!",{
                        className: 'custom-toast-error',
                        bodyClassName: 'custom-toast-error-container',
                        closeButtonClassName: 'custom-toast-error-close-button',
                        onClose: () => {}
                    });
                }else {
                    setTimeout(() => {
                        setLoading(false);
                        toast.error("User not found!", {
                            className: 'custom-toast-error',
                            bodyClassName: 'custom-toast-error-container',
                            closeButtonClassName: 'custom-toast-error-close-button',
                            onClose: () => {}
                        });
                    }, 1000);
                }
            }

        } catch (error) {
            setLoading(false)
            console.error(error);
        }
    }

    const handleOnChangeKey = (e) => {
        const key = e.target.value
        setKeySuccess(key)
    }

    const [keyVerified,setKeyVerified] = useState(false)

    const handleVerifyKey = () => {

        toast.dismiss()
        setLoading(true);
        if (key === keySuccess) {
            // setKeyVerified(true)
            setTimeout(() => {
                setLoading(false);
                setKeyVerified(true)
            }, 1000);
        } else {
            setTimeout(() => {
                setLoading(false);
                toast.error("Expired/Invalid key!",{
                    className: 'custom-toast-error',
                    bodyClassName: 'custom-toast-error-container',
                    closeButtonClassName: 'custom-toast-error-close-button',
                    onClose: () => {}
                });
            }, 1000);
        }
    }

    const handleBackFalse = () => {
        setUserFound(false)
        setKeyVerified(false)
    }
    
  return (
    <div className='MainForgotPassDiv'>
        <div className="ForgotPassSecondDiv">
            <div className='ForgotPassimageAndEMail'>
                <img className='forgetImage' src={forgetImage} alt="" />
                <div className='ForgotPassText'>
                    Forgot Your Password?
                </div>
                <div className='ForgotPassTextDiv'>
                    Enter your email and we’ll help you reset your password.
                </div>
                {keyVerified ? (
                    <div className='DivInputContainer'>
                        <div className='ForgotPassTextBoxDiv'>
                            <input 
                            className='ForgotPassTextBoxInputDiv'
                            type='text'
                            value={password.password || ''}
                            // disabled={userFound}
                            placeholder='Enter new password'
                            onChange={(e) => handleOnChangePassword(e,'password')}
                            />
                        </div>
                        <div className='ForgotPassTextBoxDiv'>
                            <input 
                            className='ForgotPassTextBoxInputDiv'
                            type='text'
                            value={password.confirmPass || ''}
                            // disabled={userFound}
                            placeholder='Enter password again'
                            onChange={(e) => handleOnChangePassword(e,'confirmPass')}
                            />
                        </div>
                        <div className='ForgotPassTextBoxDiv ForgotPassTextBoxDivBtnDiv'>
                            <button onClick={handleSubmit}>Continue</button>
                        </div>
                       
                    </div>
                ) : (
                    <div className='DivInputContainer'>
                        <div className='ForgotPassTextBoxDiv'>
                            <input 
                            className={`ForgotPassTextBoxInputDiv ${userFound ? "userFoundINput" : ""}`}
                            type='text'
                            disabled={userFound}
                            placeholder='Enter your email'
                            onChange={handleOnChangeEmail}
                            />
                            {userFound ? (
                                <img className={animate ? 'animated' : ''} src={check} alt='?'/>
                            ) : (!userFound && loading) ? (
                                <Lottie className='lottieLoadForgot' animationData={Load} loop={true} />
                            ) : (
                                <button className='ForgotPassBtnContinue' onClick={handleSendKey}>Verify</button>
                            )}
                        </div>
                        {userFound && (
                            <div className='ForgotPassTextBoxDiv'>
                                <input 
                                className={`ForgotPassTextBoxInputDiv ${keyVerified ? "userFoundINput" : ""}`}
                                type='password'
                                disabled={keyVerified}
                                placeholder={`Enter key in ${formattedTime}s`}
                                onChange={handleOnChangeKey}
                                />
                                {keyVerified ? (
                                    <img className={animate ? 'animated' : ''} src={check} alt='?'/>
                                ) : (!keyVerified && loading) ? (
                                    <Lottie className='lottieLoadForgot' animationData={Load} loop={true} />
                                ) : (
                                    <button className='ForgotPassBtnContinue' onClick={handleVerifyKey}>Verify</button>
                                )}
                            </div>
                        )}
                    </div>
                )}
                {keyVerified ? (
                    <span className='ForgotPassimageAndEMail_BackBtn_Div' onClick={handleBackFalse}><img className='ForgotPassimageAndEMail_BackBtn' src={Back} alt="" />Back</span>
                ) : (
                    <span className='ForgotPassimageAndEMail_BackBtn_Div' onClick={() => navigate('/')}><img className='ForgotPassimageAndEMail_BackBtn' src={Back} alt="" />Back</span>
                )}
                
            </div>
        </div>
        {/* <img src={forgetImage} alt="" className='w-100 h-75 mt-3' /> */}
    </div>
  );
}

export default ForgetPass;


